import { API, Auth, graphqlOperation } from 'aws-amplify';
import { createOrder } from 'graphql/mutations';
import { listOrders } from 'graphql/queries';
import _ from 'lodash';

const saveOrder = async (item) => {
  let res = null;
  if (_.isEmpty(item)) return false;
  try {
    const { attributes } = await Auth.currentAuthenticatedUser();
    const orderDetails = {
      userId: attributes.sub,
      RequirementId: item?.specificationId,
      products: JSON.stringify(item?.products),
      totalHT: item?.totalHT
    };
    res = await API.graphql({ query: createOrder, variables: { input: orderDetails } });
  } catch (e) {
    console.error(e.toString());
  }
  return res;
};

const fetchOrders = async () => {
  let data = [];
  try {
    const { attributes } = await Auth.currentAuthenticatedUser();
    const apiData = await API.graphql(graphqlOperation(listOrders, {
      filter: {
        userId: {
          eq: attributes.sub
        }
      }
    }));
    data = apiData;
  } catch (e) {
    console.error(e.toString());
  }
  return data;
};

export {
  saveOrder,
  fetchOrders
};
